import { getConfig } from '@config';

const isDev = getConfig().environment === 'dev';
export const MEDIA_SERVICE = isDev ? 'https://dev.withjoy.com/media' : 'https://withjoy.com/media';
export const PPI = 72;
export const DEFAULT_CUT_MARGIN_INCHES = 0.125;

export enum StationeryPaperSize {
  A2 = 'A2',
  A7 = 'A7',
  // 4x6/6x4 — postcards and magnets. Previously these fell through to A7,
  // which silently keyed 4x6 orders to A7 card-type/envelope config.
  postcard4x6 = 'postcard4x6',
  foam18X24 = 'foam18X24',
  foam24X36 = 'foam24X36',
  napkin475 = 'napkin475',
  napkin650 = 'napkin650',
}
